import Cookie from 'js-cookie';
function generateGuid() {
  var result = '', n = 0;
  while (n < 32) {
    result += (~[8, 12, 16, 20].indexOf(n++) ? '-' : '') +
      Math.floor(Math.random() * 16).toString(16).toUpperCase();
  }
  return result;
}

let allowSpotlightModalFlow = function (user) {
  return user.spotlight_active && !hasVisitedProfileAndSpotlight(user);
}

let hasVisitedProfileAndSpotlight = function (user) {
  return (getSpotlightVisitsCookie(user) && getProfileVisitsCookie(user));
}

let getSpotlightVisitsCookie = function (user) {
  if (!(user && user.id)) {
    return false
  }
  return Cookie.get(`spotlight-visits-${user.id}`) || false;
};
let getProfileVisitsCookie = function (user) {
  if (!(user && user.id)) {
    return false
  }
  return Cookie.get(`profile-visits-${user.id}`) || false;
};
let setSpotlightVisitsCookie = function (user) {
  if (user && user.id) {
    Cookie.set(`spotlight-visits-${user.id}`, true, { expires: new Date(new Date().getTime() + 30 * 60 * 1000) });
  }
};
let setProfileVisitsCookie = function (user) {
  if (user && user.id) {
    Cookie.set(`profile-visits-${user.id}`, true, { expires: new Date(new Date().getTime() + 30 * 60 * 1000) });
  }
};
let getGetRecsUserIdentifier = function () {
  return Cookie.get('get-recs-user-identifier') || null;
}
let setGetRecsUserIdentifier = function () {
  const exisitingValue = getGetRecsUserIdentifier();
  if (exisitingValue) {
    return;
  }
  Cookie.set('get-recs-user-identifier', generateGuid(), { expires: 365 });
}
export default {
  allowSpotlightModalFlow,
  hasVisitedProfileAndSpotlight,
  getProfileVisitsCookie,
  getSpotlightVisitsCookie,
  setSpotlightVisitsCookie,
  setProfileVisitsCookie,
  getGetRecsUserIdentifier,
  setGetRecsUserIdentifier
};
